import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'

import AutoTypeRepository from '@/shared/http/repositories/configuration/autotype'
import BrandRepository from '@/shared/http/repositories/configuration/brand'
import AutoModelRepository from '@/shared/http/repositories/configuration/automodel'
import AutoModelModel from '@/shared/models/configuration/automodelmodel'
import AutoModelForms from './automodel-form'

export default {
  name: 'AutoModel',
  props: {
    showMenuCfg: {
      type: Boolean,
      default: true
    }
  },
  mixins: [ActionsForm],
  data () {
    return {
      data: AutoModelModel,
      form: AutoModelForms
    }
  },
  components: {
    Cfg
  },
  mounted () {
    this.onLoadAllAutoType()
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    },
    HasShowMenuCfg: function () {
      return this.showMenuCfg
    }
  },
  methods: {
    onLoad () {
      loading.push()
      AutoModelRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      // --> Set manual
      this.form.autoTypeID.value = obj.brand.autoTypeID
      this.onChangeType()

      this.polling = setInterval(() => {
        this.setBranch(obj.brandID)
      }, 500)

      loading.pop()
    },
    onCreate () {
      loading.push()
      AutoModelRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      AutoModelRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      AutoModelRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllAutoType () {
      loading.push()
      AutoTypeRepository.GetAll()
        .then((response) => {
          this.form.autoTypeID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllBrand (id) {
      this.form.brandID.options = []
      if (id) {
        loading.push()
        BrandRepository.GetAllByAutoTypeID(id)
          .then((response) => {
            this.form.brandID.options = this.onResultDropdown(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onChangeType () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllBrand(self.form.autoTypeID.value)
      }, 500)
    },
    setBranch (brandID) {
      if (brandID) {
        var options = this.form.brandID.options
        if (options.length > 0) {
          clearInterval(this.polling)
          this.form.brandID.value = brandID
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/automodel/automodel.js